import type { ToolDefinition } from "@/types/toolRegistry";

export const BUILTIN_TOOL_DEFINITIONS: ToolDefinition[] = [
  {
    id: "thread",
    name: "Chat Thread",
    description: "Create and manage chat threads",
    provider: "internal",
    executorKey: "thread",
    isBuiltin: true,
    permissions: ["cap-create-thread"],
    operations: [
      {
        name: "create",
        description: "Create a new chat thread with seed content",
        sideEffect: true,
        inputSchema: { type: "object", properties: { title: { type: "string" }, content: { type: "string" }, agentId: { type: "string" } } },
        outputSchema: { type: "object", properties: { threadId: { type: "string" } } },
      },
    ],
  },
  {
    id: "kb",
    name: "Knowledge Base",
    description: "Create and update KB documents",
    provider: "internal",
    executorKey: "kb",
    isBuiltin: true,
    permissions: ["cap-create-kb-document"],
    operations: [
      {
        name: "create_document",
        description: "Create a knowledge base document",
        sideEffect: true,
        inputSchema: {
          type: "object",
          properties: {
            title: { type: "string" },
            content: { type: "string" },
            spaceId: { type: "string" },
            topicId: { type: "string" },
            includeInRag: { type: "boolean" },
          },
        },
        outputSchema: { type: "object", properties: { documentId: { type: "string" } } },
      },
    ],
  },
  {
    id: "rag",
    name: "RAG Index",
    description: "Index content into searchable RAG storage",
    provider: "internal",
    executorKey: "rag",
    isBuiltin: true,
    permissions: ["cap-index-rag"],
    operations: [
      {
        name: "index_kb",
        description: "Embed a KB document",
        sideEffect: true,
        inputSchema: { type: "object", properties: { documentId: { type: "string" } } },
        outputSchema: { type: "object" },
      },
      {
        name: "index_integration",
        description: "Index into integration RAG chunks",
        sideEffect: true,
        inputSchema: {
          type: "object",
          properties: {
            source: { type: "string" },
            externalId: { type: "string" },
            title: { type: "string" },
            content: { type: "string" },
          },
        },
        outputSchema: { type: "object" },
      },
      {
        name: "index_thread",
        description: "Embed a chat thread",
        sideEffect: true,
        inputSchema: { type: "object", properties: { threadId: { type: "string" } } },
        outputSchema: { type: "object" },
      },
    ],
  },
  {
    id: "clickup",
    name: "ClickUp",
    description: "ClickUp task management",
    provider: "clickup",
    executorKey: "clickup",
    isBuiltin: true,
    permissions: ["cap-clickup-write"],
    operations: [
      {
        name: "create_task",
        description: "Create ClickUp tasks",
        sideEffect: true,
        requiresApproval: true,
        inputSchema: {
          type: "object",
          properties: { listId: { type: "string" }, tasks: { type: "array" } },
        },
        outputSchema: { type: "object" },
      },
    ],
  },
  {
    id: "gmail",
    name: "Gmail",
    description: "Gmail inbox actions",
    provider: "google",
    executorKey: "gmail",
    isBuiltin: true,
    permissions: ["cap-gmail-write"],
    operations: [
      {
        name: "apply_label",
        description: "Apply a label to a message",
        sideEffect: true,
        requiresApproval: true,
        inputSchema: { type: "object", properties: { messageId: { type: "string" }, labelId: { type: "string" } } },
        outputSchema: { type: "object" },
      },
      {
        name: "archive",
        description: "Archive a message",
        sideEffect: true,
        requiresApproval: true,
        inputSchema: { type: "object", properties: { messageId: { type: "string" } } },
        outputSchema: { type: "object" },
      },
      {
        name: "trash",
        description: "Move a message to trash",
        sideEffect: true,
        requiresApproval: true,
        inputSchema: { type: "object", properties: { messageId: { type: "string" } } },
        outputSchema: { type: "object" },
      },
      {
        name: "create_draft",
        description: "Create an email draft",
        sideEffect: true,
        inputSchema: { type: "object", properties: { to: { type: "string" }, subject: { type: "string" }, body: { type: "string" } } },
        outputSchema: { type: "object" },
      },
    ],
  },
  {
    id: "telegram",
    name: "Telegram",
    description: "Send Telegram messages",
    provider: "telegram",
    executorKey: "telegram",
    isBuiltin: true,
    permissions: ["cap-telegram-write"],
    operations: [
      {
        name: "send_message",
        description: "Send a Telegram message",
        sideEffect: true,
        requiresApproval: true,
        inputSchema: {
          type: "object",
          properties: { chatId: { type: "string" }, text: { type: "string" } },
        },
        outputSchema: { type: "object" },
      },
    ],
  },
  {
    id: "http",
    name: "HTTP",
    description: "Generic HTTP requests",
    provider: "http",
    executorKey: "http",
    isBuiltin: true,
    permissions: [],
    operations: [
      {
        name: "request",
        description: "Make an HTTP request",
        sideEffect: true,
        inputSchema: {
          type: "object",
          properties: { url: { type: "string" }, method: { type: "string" }, body: { type: "string" } },
        },
        outputSchema: { type: "object" },
      },
    ],
  },
];
